module.exports = __webpack_public_path__ + "img/icon-run.e54a1587.svg";